import React, { memo, useEffect, useState, useContext } from "react";
import s from "./index.module.less";
import { connect } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import WebIM from "@/utils/WebIM";
import { CHAT_SERVICE_ID, CHAT_TYPE, DRAW_SERVICE_ID } from "@/consts";
import { LlwAiAiShow, LlwAiMainPageClick, LlwAiMainPageShow } from "@/utils/sensorsFunc";
import { filterData, getUrlParams, checkLogin } from "@/utils/common";
import dealRooms from "@/utils/dealRooms";
import InfiniteScroll from "react-infinite-scroll-component";
import { message, Tooltip } from "antd";
import Confirm from "@/views/AIEdit/components/Confirm/index";
import { isSavedWorkRecord } from "@/views/AIEdit/work";
import { saveWorkImage } from "@/api/work";
import { getUserInfo } from "@/api/index";
import { REDRAW_MODE, WORKING_STATUS } from "@/views/AIEdit/consts";
import { uploadBase64ImageToOSS } from '@/utils/oss';
import { AppCtx } from '@/App';
import Avatar from "@/componentsNew/Avatar/index";
import MenuIcon from '@/assets/images/introd/menu_icon.png';

let clickedMenuItem = {};

const AppSideBar = (props) => {
    const {
        userInfo,
        joinedServerInfo,
        serverRole,
        updateAiSource,
        setJoinedServerInfo,
        setServerRole,
        currentChannelId,
        setCurrentChannelId,
        setAutoSelectFlag,
        setChannelMemberVisible,
        setServerFormVisible,
        unReadAtDict,
        unReadDict,
        setCurrentChatInfo,
        setServerChannelMap,
        workingStatus,
        currentReDrawWorkID,
        currentWorkImageItem,
        updateRefreshWorkSaveRecord,
        updateCurrentReDrawWorkID,
        currentReDrawMode
    } = props;
    const [activeMenuItemKey, setActiveMenuItemKey] = useState('AIDraw') // 激活菜单
    const [commonChatServer, setCommonChatServer] = useState({}); // 公共聊天服务器(房间)
    const [myServerList, setMyServerList] = useState([]); // 个人房间
    const [confirmVisible, setConfirmVisible] = useState(false); // 切换确认弹框
    const location = useLocation();
    const { serverId, channelId } = useParams();
    const LIMIT = 20;
    const reDrawModeWithoutWorkID = [REDRAW_MODE.CUTOUT, REDRAW_MODE.ADD_WATERMARK, REDRAW_MODE.CLIP, REDRAW_MODE.SMART_MARK,REDRAW_MODE.LIGHT] // 前端生成结果图的改图模式：抠图、加水印、裁剪
    const { genBase64ImageRef, recordSaveParams,toastHandleRef } = useContext(AppCtx)
    
    // 更新ai_source
    const _updateAiSource = (ai_source) => {
        updateAiSource(+ai_source);
        if (ai_source === '1') {
            LlwAiAiShow({
                ai_show: '1', //事件枚举 1-绘画面板展示；2-共创面板展示；3-训练-正式版本展示；4-训练-训练版本展示；5-训练-新建训练展示；
                room_id: serverId, //房间id  上报当前房间ID
                room_member_nums: 0, //房间内人数  上报当前房间内人数
                pindao_id: channelId, //频道id  上报当前所在频道id
            });
        }
    };

    const getJoinedServers = ({cursor = ""}) => {
        // console.log('userInfo...', userInfo)
        WebIM.conn.getJoinedServers({
            pageSize: LIMIT,
            cursor
        }).then(async (res) => {
            const urlParams = getUrlParams();
            const { list, cursor } = res.data;
            /* if (list.length > 0 && serverId && urlParam.indexOf('from=xuanran') === -1) {
                if (!serverId || !currentChannelId) {
                    setCurrentChannelId(0);
                    if (!channelId || !serverId) {
                        setAutoSelectFlag(true);
                    }
                }
                navigate("/main/AIDraw");
                // navigate(`/main/channel/${serverId ? serverId : DRAW_SERVICE_ID[process.env.REACT_APP_ENV]}/${channelId ? channelId : 0}${location.search ? location.search.replace(/&amp;/g, '&') : ''}`);
            } */
            let ls = [];

            // 未读消息初始值设置&&获取server和channel映射关系
            if (joinedServerInfo?.list?.length) {
                //筛选已存在列表中的server(创建或加入时列表已自动插入server数据)
                const resList = filterData(joinedServerInfo.list, list, "id");
                ls = [...joinedServerInfo?.list, ...resList];
            } else {
                ls = list;
            }

            /**
              * B! 房间创建、跳转
              * 判断页码 1 首页；2 最后一页(检查是否有下一个 cursor，getJoinedServers通过course 获取下一页)
              * 测试用例：
              * 1. [通过]正常进入，是否创建‘默认房间’，名字显示“我的房间”
              * 2. 正常进入，客人的‘默认房间’，名字显示'${昵称}的房间'
              * 3. [通过]‘云渲染’跳转，是否创建‘云渲染房间’；‘云渲染房间’是否被选中；‘云渲染房间’是否在首位； 滚动到最后一页，是否出现重复的云渲染房间；
              * 4. [通过]‘云渲染’跳转，是否打开改图弹窗；
              */
            let pageType;
            if (cursor === undefined) pageType = 2;
            if (!joinedServerInfo?.list?.length) pageType = 1;
            const result = await dealRooms.update(ls, userInfo, pageType, serverId);
            const { rooms, redirectServerId, redirectChannelId, extra, myRooms } = result;

            // 更新个人列表数据
            setJoinedServerInfo({list: rooms, cursor, loadCount: list.length});
            // 公共聊天房间
            const chatServer = rooms.find(item => item.id === CHAT_SERVICE_ID[process.env.REACT_APP_ENV]);
            // console.log('chatServer...', rooms, chatServer);
            setCommonChatServer(chatServer || {});
            // 个人房间，包括当前用户创建的和当前用户加入的
            const serverList = rooms.filter(item => item.id !== DRAW_SERVICE_ID[process.env.REACT_APP_ENV] && item.id !== CHAT_SERVICE_ID[process.env.REACT_APP_ENV]);
            setMyServerList(serverList);

            // 频道跳转, 延迟是因为1S内有其他自动触发的编程式导航
            if (redirectServerId && redirectChannelId){
                setTimeout(()=> {
                    setChannelMemberVisible(true);
                    setCurrentChannelId(redirectChannelId);
                    navigate(`/main/channel/${redirectServerId}/${redirectChannelId}?from=xuanran&extra=${extra}`);
                }, 1200);
            }

            if (myRooms.length && urlParams.channel === 'ai_customerservice') {
                const { id: serverId } = myRooms[0]
                setTimeout(()=> {
                    setChannelMemberVisible(true);
                    setCurrentChannelId(0);
                    navigate(`/main/channel/${serverId}/0/?channel=ai_customerservice`);
                    document.getElementById("coverLoadView").style.display = 'none';
                }, 1200); 
            }
        }).catch((err) => {
            console.log('.....err', err)
        })    
    };

    useEffect(() => {
        if(userInfo?.user_id){
            getJoinedServers({cursor: ""});
        }
        const urlParams = getUrlParams();
        // 更新ai_source
        if (urlParams?.ai_source && !isNaN(urlParams.ai_source)) {
            _updateAiSource(urlParams.ai_source);
        } else {
            updateAiSource(localStorage.getItem('openByWebApp') ? 8 : 4);
        }
    }, [userInfo]);

    const loadMoreData = () => {
        getJoinedServers({cursor: joinedServerInfo?.cursor});
    };

    /* useEffect(() => {
        console.log('unReadAtDict...', unReadAtDict);
    }, [unReadAtDict]) */

    const getAllAtNum = () => {
        // console.log('getAllAtNum....', unReadAtDict, userInfo)
        let atNum = 0;
        if (!userInfo) return atNum
        // 艾特消息
        const unReadAtData = unReadAtDict?.[userInfo.user_id];
        for (let i = 0; i < myServerList.length; i++) {
            const item = myServerList[i];
            if (unReadAtData && unReadAtData[item.id]) {
                for (const key in unReadAtData[item.id]) {
                    atNum = atNum + unReadAtData[item.id][key];
                }
            }
        }
        return atNum;
    }

    const getUnReadNum = (id) => {
        let atNum = 0;
        let haveUnRead = false;
        if (!userInfo) return { atNum, haveUnRead };
        // 艾特消息
        if (unReadAtDict?.[userInfo.user_id] && unReadAtDict?.[userInfo.user_id][id]) {
            for (const key in unReadAtDict[userInfo.user_id][id]) {
                atNum = atNum + unReadAtDict[userInfo.user_id][id][key];
            }
        }
        // 未读消息
        if (unReadDict?.[userInfo.user_id] && unReadDict?.[userInfo.user_id][id]) {
            for (const key in unReadDict[userInfo.user_id][id]) {
                if (unReadDict[userInfo.user_id][id][key]) {
                    haveUnRead= true;
                }
            }
        }
        return { atNum, haveUnRead };
    }

    const UnReadInfo = ({ id }) => {
        const { atNum, haveUnRead } = getUnReadNum(id);
        if (atNum > 0) { // 有@消息，显示艾特数
            return  (<span className={`${s.unReadBadge} ${atNum > 9 ? s.longText: ''}`}>{atNum > 99 ? '99+' : atNum}</span>);
        } else if (atNum === 0 && haveUnRead) { // 有未读消息，无@消息
            return (<span className={s.unReadPoint}></span>);
        } else {
            return '';   // 无未读消息也无@消息
        };
    }

    const navigate = useNavigate();
    const navigateToPage = () => {
        const { url, key } = clickedMenuItem;
        setActiveMenuItemKey(key);
        if (url.indexOf('/main/channel') > -1)  setCurrentChannelId(0);
        navigate(url);
    }

    // LlwAiMainPageShow上报
    const LlwAiMainPageShowReport = () => {
        // 确保用户在埋点前注册，强制重新调用一次
        getUserInfo().then(() => { 
          LlwAiMainPageShow({
            main_page_show: '6',
            change_tfunction: 1
          })
        })
    }

    const handleMenuItemClick = async (url, key) => {
        if (activeMenuItemKey === key) return;
        clickedMenuItem = { url, key };
        if (url === '/main/AIEditDetailEnhance') {
            LlwAiMainPageClick({
                main_page_click: '6'
            })
        }
        if (url === '/main/AIEdit') {
            LlwAiMainPageShowReport()
        }
        if (location.pathname === '/main/AIEdit' && url !== '/main/AIEdit' && currentReDrawWorkID) { 
            // 如果离开时当前改图work未完成，则记录workID到本地缓存中，再次进入页面时据此回填页面数据和状态
            if (workingStatus && workingStatus !== WORKING_STATUS.DONE) localStorage.setItem('cacheUnFinishWorkID', currentReDrawWorkID);
            const isSaved = await isSavedWorkRecord(currentReDrawWorkID);
            if (isSaved) {
                navigateToPage();
            } else {
                setConfirmVisible(true);
            }
        } else if (location.pathname === '/main/AIEdit' && url !== '/main/AIEdit' && (reDrawModeWithoutWorkID.includes(currentReDrawMode) || currentReDrawMode === REDRAW_MODE.COLOR_MIXING)) {
            if (!recordSaveParams.current.has_edited) {
                navigateToPage();
            } else {
                setConfirmVisible(true);
            }
        } else {
            navigateToPage();
        }
    };

    useEffect(() => {
        // console.log('location....', location, serverId);
        if (serverId) {
            // 这里如果是跳转到公共绘画页面，则重定向到新版AI绘画页面
            if (serverId === DRAW_SERVICE_ID[process.env.REACT_APP_ENV]) {
                navigate(`/main/AIDraw${location.search || ''}`);
            } else {
                setActiveMenuItemKey(serverId);
            }
        } else if (location.pathname) {
            const pathname = location.pathname;
            const index = pathname.lastIndexOf('/');
            setActiveMenuItemKey(pathname.slice(index + 1));
        }
    }, [location]);

    // 获取已加入房间数据
    const getJoinedServersList = async ({cursor = ""}) => {
        const res = await WebIM.conn
            .getJoinedServers({
                pageSize: LIMIT,
                cursor
            });
        const { list, cursor: _cursor } = res.data;
        let ls = [];
        if (joinedServerInfo?.list?.length) {
            const resList = filterData(joinedServerInfo.list, list, "id");
            ls = [...joinedServerInfo?.list, ...resList];
        } else {
            ls = list;
        }
        let pageType;
        if(_cursor === undefined) pageType = 2
        if(!joinedServerInfo?.list?.length) pageType = 1
        const result = await dealRooms.update(ls, userInfo, pageType, serverId)
        const { rooms } = result
        return { list: rooms, cursor: _cursor, loadCount: list.length };
    };

    useEffect(() => {
        // console.log('serverId....', serverId, serverId === DRAW_SERVICE_ID[process.env.REACT_APP_ENV], userInfo, serverRole);
        if(!serverId || serverId === DRAW_SERVICE_ID[process.env.REACT_APP_ENV]) {
            return;
        }
        
        if (!userInfo?.user_id) return;
        
        !serverRole[serverId] && 
        WebIM.conn.getServerRole({serverId}).then((res) => {
            setServerRole({serverId, role: res.data.role});
        });

        /**
         * B！ 房间选中置顶
         * 测试用例：
         * 1. [通过]点击个人房间是否置顶
         * 2. [通过]首次进入房间是否置顶
         */
        getJoinedServersList({cursor: ""}).then(({ list }) => {
            if(list?.length > 0) {
                dealRooms.sort(list, serverId).then(rooms => {
                    if(rooms && rooms.length > 0){
                        setJoinedServerInfo({
                            ...joinedServerInfo,
                            list: rooms
                        });
                        // 个人房间，包括当前用户创建的和当前用户加入的
                        const serverList = rooms.filter(item => item.id !== DRAW_SERVICE_ID[process.env.REACT_APP_ENV] && item.id !== CHAT_SERVICE_ID[process.env.REACT_APP_ENV]);
                        setMyServerList(serverList);
                    }
                })
            }
        });
    }, [serverId, userInfo]);

    useEffect(() => {
        if (currentChannelId) {
            setCurrentChatInfo({
                chatType: CHAT_TYPE.groupChat,
                id: currentChannelId
            })
            // 清空未读数
            setServerChannelMap({
                serverId,
                channelId: currentChannelId,
                unReadNum: 0,
            })
        } else {
            setCurrentChatInfo({
                chatType: undefined,
                id: undefined
            })
        }
    }, [currentChannelId]);

    const leaveAndNavigateToPage = () => {
        setConfirmVisible(false);
        if (!reDrawModeWithoutWorkID.includes(currentReDrawMode) || currentReDrawMode !== REDRAW_MODE.COLOR_MIXING) updateCurrentReDrawWorkID('');
        navigateToPage()
    }

    const saveRecordAndNavigateToPage = () => {
        setConfirmVisible(false);
        if (reDrawModeWithoutWorkID.includes(currentReDrawMode) || currentReDrawMode === REDRAW_MODE.COLOR_MIXING || currentReDrawMode===REDRAW_MODE.LIGHT) {
            uploadImageAndSaveRecord();
            return;
        }
        saveWorkImage({
            work_id: currentReDrawWorkID,
            img_id: currentWorkImageItem?.img_id
        }).then(res => {
            if (res.status === 200) {
                updateCurrentReDrawWorkID('');
                updateRefreshWorkSaveRecord(true);
                navigateToPage();
            }
        })
    }

    // 上传保存图片生成改图记录
    const uploadImageAndSaveRecord = async () => {
        toastHandleRef.current&&toastHandleRef.current({
            type: 'loading',
            text: '生成图片中...'
        })
        const tempParams = {
			light_color: recordSaveParams.current.light_color,
		    strength_value: recordSaveParams.current.strength_value,
			exposure_value: recordSaveParams.current.exposure_value,
			pointLight_list: recordSaveParams.current.pointLight_list,
			spotLight_list: recordSaveParams.current.spotLight_list,
		}
        const base64Image = await genBase64ImageRef.current()
        const img_url = await uploadBase64ImageToOSS(base64Image)
        let params = {
            redraw_mode: currentReDrawMode,
            reference_img: recordSaveParams.current.reference_img,
            img_url
        }
        if (currentReDrawMode === REDRAW_MODE.COLOR_MIXING) { 
            params = {
                ...params,
                brightness:  recordSaveParams.current.brightness,
                contrast:  recordSaveParams.current.contrast,
                saturation:  recordSaveParams.current.saturation,
                temperature:  recordSaveParams.current.temperature,
                hue:  recordSaveParams.current.hue
            }
        }
        if (currentReDrawMode === REDRAW_MODE.SMART_MARK) {
            params = {
                ...params,
                annotation_title: recordSaveParams.current.annotation_title,
				annotation_notes: recordSaveParams.current.annotation_notes,
                annotation: recordSaveParams.current.annotation
            }
        }
        if (currentReDrawMode === REDRAW_MODE.LIGHT) { 
            params = {
                ...params,
                ...tempParams
            }
        }
        saveWorkImage(params).then(res => {
            if (res.status === 200) {
                setConfirmVisible(false);
                updateRefreshWorkSaveRecord(true);
                if (currentReDrawMode === REDRAW_MODE.SMART_MARK) recordSaveParams.current = {}
                navigateToPage();
            }
            setConfirmVisible(false);
        })
    }
    const goToChannel = (commonChatServer) => {
        if (!checkLogin()) return
        handleMenuItemClick(`/main/channel/${commonChatServer.id || 0}/0`, commonChatServer.id)
    }

    return (
        <>
            <div className={s.appSideBarWrap}>
                <div className={s.menuNavWrap}>
                    <div className={s.commonWrap}>
                        <div className={`${s.menuNavItem} ${activeMenuItemKey === 'AIDraw' ? s.active : ''}`} onClick={() => handleMenuItemClick('/main/AIDraw', 'AIDraw')}>
                            <i className="iconfont icon-huihua1"></i>
                        </div>
                        <div className={`${s.menuNavItem} ${s.menuNavIcon} ${activeMenuItemKey === 'AIEditDetailEnhance' ? s.active : ''}`} onClick={() => handleMenuItemClick('/main/AIEditDetailEnhance', 'AIEditDetailEnhance')}>
                            <img src={MenuIcon} className={s.menuIcon} alt="菜单图标" />
                        </div>
                        <div className={`${s.menuNavItem} ${activeMenuItemKey === 'AIEdit' ? s.active : ''}`} onClick={() => handleMenuItemClick('/main/AIEdit', 'AIEdit')}>
                            <i className="iconfont icon-gaitu"></i>
                        </div>
                        <div className={`${s.menuNavItem} ${activeMenuItemKey === commonChatServer.id ? s.active : ''}`} onClick={() => goToChannel(commonChatServer)}>
                            <i className="iconfont icon-liaotian"></i>
                            { userInfo?.user_id && <UnReadInfo id={commonChatServer.id} />}
                            
                        </div>
                        <div className={`${s.menuNavItem} ${activeMenuItemKey === 'coCreateHomePage' ? s.active : ''}`} onClick={() => handleMenuItemClick('/main/coCreateHomePage', 'coCreateHomePage')}>
                            <i className="iconfont icon-AIGC"></i>
                        </div>
                    </div>
                    <div className={s.divider}></div>
                    { userInfo?.user_id ? 
                    <div id="serverScrollWrapId" className={`${s.serversWrap} ${getAllAtNum() ? s.showBadge : ''}`}>
                        <InfiniteScroll
                            dataLength={joinedServerInfo?.list?.length || 0}
                            next={loadMoreData}
                            hasMore={joinedServerInfo?.loadCount === LIMIT}
                            loader={<></>}
                            endMessage={<></>}
                            scrollableTarget="serverScrollWrapId"
                        >
                            {   
                                myServerList.map(item => {
                                    return (
                                        <Tooltip
                                            title={item.name}
                                            placement="right"
                                            overlayClassName="toolTip3"
                                            key={item.id}
                                            align={{ offset: [15, 0] }}
                                        >
                                            <div className={`${s.menuNavItem} ${s.serverItem} ${activeMenuItemKey === item.id ? s.active : ''} ${item.icon ? s.imageBox : ''}`}  onClick={() => handleMenuItemClick(`/main/channel/${item.id}/0`, item.id)}>
                                                {
                                                    item.icon && item.icon !== 'https://3d66-imgo.oss-cn-hangzhou.aliyuncs.com/ai/reference_image/202504/179175740_1744880540866.png' ?
                                                    <div className={s.serverImage} >
                                                        <img src={item.icon}/>
                                                    </div>
                                                    :
                                                    +item.owner === userInfo.user_id ?
                                                    <span className={s.text}>我的房间</span>
                                                    :
                                                    <i className="iconfont icon-fangjian1"></i>
                                                }
                                                <UnReadInfo id={item.id} />
                                            </div>
                                        </Tooltip>
                                    );
                                })
                            }
                        </InfiniteScroll>
                    </div> :
                    <div id="serverScrollWrapId" className={`${s.serversWrap}`}>{/** 空容器-占位 */}</div>
                    }
                    <div className={s.divider}></div>
                    <div className={s.personWrap}>
                        <Tooltip
                            title="创建房间"
                            placement="right"
                            overlayClassName="toolTip3"
                            align={{ offset: [15, 0] }}
                        >
                            <div className={s.menuNavItem} onClick={() => { if(!checkLogin()){ return }; setServerFormVisible(true) }}>
                                <i className="iconfont icon-tianjia"></i>
                            </div>
                        </Tooltip>
                        <Tooltip
                            title="作品管理"
                            placement="right"
                            overlayClassName="toolTip3"
                            align={{ offset: [15, 0] }}
                        >
                            <div className={`${s.menuNavItem} ${activeMenuItemKey === 'workManagePage' ? s.active : ''}`} onClick={() => handleMenuItemClick('/main/workManagePage', 'workManagePage')}>
                                <i className="iconfont icon-guanli"></i>
                            </div>
                        </Tooltip>
                        {/* <Avatar size={44}/> */}
                    </div>
                </div>
            </div>
            <Confirm 
                open={confirmVisible}
                content={"当前改图结果未保存，离开当前编辑页将会丢失记录"}
                cancelBtnText="直接离开"
                okBtnText="保存记录后离开"
                onClose={() => setConfirmVisible(false)}
                onCancel={() => leaveAndNavigateToPage()}
                onConfirm={() => saveRecordAndNavigateToPage()} 
            /> 
        </>
    );
};

const mapStateToProps = ({ app, server, channel, work }) => {
    return {
        userInfo: app.userInfo,
        joinedServerInfo: server.joinedServerInfo,
        serverRole: app.serverRole,
        currentChannelId: channel.currentChannelId,
        unReadAtDict: app.unReadAtDict,
        unReadDict: app.unReadDict,
        workingStatus: work.reDrawWorkStatus,
        currentReDrawWorkID: work.currentReDrawWorkID,
        currentWorkImageItem: work.currentWorkImageItem,
		currentReDrawMode: work.currentReDrawMode
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setJoinedServerInfo: (params) => {
            return dispatch({
                type: "server/setJoinedServerInfo",
                payload: params
            });
        },
        setServerRole: (params) => {
            return dispatch({
                type: "app/setServerRole",
                payload: params,
            })
        },
        updateAiSource: (params) => {
            return dispatch({
                type: "app/updateAiSource",
                payload: params
            });
        },
        setCurrentChannelId: (params) => {
            return dispatch({
                type: "channel/setCurrentChannelId",
                payload: params
            });
        },
        setAutoSelectFlag: (params) => {
            return dispatch({
                type: "channel/setAutoSelectFlag",
                payload: params
            });
        },
        setChannelMemberVisible: (params) => {
            return dispatch({
                type: "channel/setChannelMemberVisible",
                payload: params
            });
        },
        setServerFormVisible: (params) => {
            return dispatch({
                type: "app/setVisible",
                payload: params
            });
        },
        setCurrentChannelId: (params) => {
            return dispatch({
                type: "channel/setCurrentChannelId",
                payload: params
            });
        },
        setCurrentChatInfo: (params) => {
            return dispatch({
                type: "app/setCurrentChatInfo",
                payload: params,
            })
        },
        setServerChannelMap: (params) => {
            return dispatch({
                type: "app/setServerChannelMap",
                payload: params
            });
        },
        updateRefreshWorkSaveRecord: (params) => {
			return dispatch({
			  type: "work/updateRefreshWorkSaveRecord",
			  payload: params
			});
		},
        updateCurrentReDrawWorkID: (params) => {
			return dispatch({
                type: "work/updateCurrentReDrawWorkID",
                payload: params
			});
		}
    };
};
export default memo(connect(mapStateToProps, mapDispatchToProps)(AppSideBar));
